import { EventBus } from '@/utils/eventBus.js'

export function useNotification() {
	const notify = (content, params) => {
		EventBus.emit('notify', { content, params })
	}

	return {
		notify
	}
}
